import React from 'react';

import { Divider } from '@material-ui/core';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';

import { ReactComponent as StandardIcon } from 'pages/Teachers/Home/assets/standard-icon.svg';
import { formatWeekRange } from 'utils/teachers/classTrends';

import styles from './styles.module.scss';

export const ClassPerformanceTrendsPanel = ({ activeTrend }) => {
  const {
    week_start,
    week_end,
    assignments_count = 0,
    students_count = 0,
    uploads_percentage = 0,
    mastery_percentages = {},
    standards = []
  } = activeTrend || {};

  const {
    celebrate = 0,
    support = 0,
    intervene = 0
  } = mastery_percentages || {};

  return (
    <>
      {activeTrend ? (
        <div className={styles.sidePanel}>
          <h4 className={styles.sidePanelTitle}>
            {formatWeekRange({
              weekStart: week_start,
              weekEnd: week_end,
              variant: 'title'
            })}
            <Divider className={styles.divider} />
          </h4>

          <div className={styles.metricsRow}>
            <div className={styles.metricItem}>
              <span className={`${styles.dot} ${styles.dotCelebrate}`} />
              <span className={styles.metricLabel}>Celebrate {celebrate}%</span>
            </div>
            <div className={styles.metricItem}>
              <span className={`${styles.dot} ${styles.dotSupport}`} />
              <span className={styles.metricLabel}>Support {support}%</span>
            </div>
            <div className={styles.metricItem}>
              <span className={`${styles.dot} ${styles.dotIntervene}`} />
              <span className={styles.metricLabel}>Intervene {intervene}%</span>
            </div>
          </div>

          <div className={styles.metaRow}>
            <div className={styles.metaItem}>
              <DescriptionOutlinedIcon className={styles.metaIcon} />
              <span>{assignments_count} Assignments</span>
            </div>
            <div className={styles.metaItem}>
              <PeopleOutlineIcon className={styles.metaIcon} />
              <span>{students_count} Students</span>
            </div>
            <div className={styles.metaItem}>
              <AssignmentOutlinedIcon className={styles.metaIcon} />
              <span>{uploads_percentage}% Uploads</span>
            </div>
          </div>

          <div className={styles.standardsSection}>
            <span className={styles.standardsLabel}>Standards:</span>
            <div className={styles.chipsContainer}>
              {standards.length > 0 ? (
                standards.map((standard) => (
                  <div key={`std-${standard}`} className={styles.chip}>
                    <StandardIcon className={styles.chipIcon} />
                    <span>{standard}</span>
                  </div>
                ))
              ) : (
                <span className={styles.noStandards}>No standards tagged</span>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className={`${styles.sidePanel} ${styles.emptyState}`}>
          <InfoOutlinedIcon className={styles.emptyIcon} />
          <h4 className={styles.emptyTitle}>No Performance Data</h4>
          <p className={styles.emptySubtext}>
            There are no performance trends available for this class yet. Select
            another class to view data.
          </p>
        </div>
      )}
    </>
  );
};
